import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { Marker } from "react-map-gl/mapbox";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import { WaypointStep } from "../../models/WaypointStep";
import { mapsIcons } from "../Helper/FontAwesomeMapsIcons";

interface WaypointStepMarkerProps {
    waypointStep: WaypointStep;
    animate: boolean;
}

const WaypointStepMarker: React.FC<WaypointStepMarkerProps> = (props) => {
    const context = React.useContext(GlobalStoreContext);
    if (!props.waypointStep || !props.waypointStep.coordinates || !props.waypointStep.icon) {
        return;
    }

    return (
        <Marker
            key={`marker-${props.waypointStep.id}`}
            longitude={props.waypointStep.coordinates[0]}
            latitude={props.waypointStep.coordinates[1]}
            draggable={false}
            anchor="center"
            offset={context.editCurrentMappable ? [0, -25] : undefined}
        >
            <FontAwesomeIcon
                icon={mapsIcons[props.waypointStep.icon]}
                beat={props.animate}
                size="3x"
                transform={{ rotate: props.waypointStep.iconRotate || 0 }}
                color={props.waypointStep.color}
            />
        </Marker>
    );
};

export default WaypointStepMarker;
